/* eslint-disable spellcheck/spell-checker */
class PincodeChecker extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.input = this.querySelector('input');
    this.btn = this.querySelector('button')
    this.failureNode = this.querySelector('[data-pincode-failure]')
    this.successNode = this.querySelector('[data-pincode-success]')
    this.estDeliveryNode = this.querySelector('[data-pincode-estdelivery]')
    this.validationErrorNode = this.querySelector('[data-pincode-validation-error]')
    this.btn.addEventListener('click',this.onPincodeCheck.bind(this));
    this.input.addEventListener('input',this.onPincodeCheck.bind(this));
  }

  onPincodeCheck() {
    this.checkPincodeAvailability();
    this.handleInput();
  }

  checkPincodeAvailability() {
    const pincode = this.input.value.trim();
    this.querySelectorAll('p').forEach((elem) => elem.classList.add('hidden'))

    // Validate the pincode
    if (!pincode || pincode.length < 6 || isNaN(pincode)) {
      this.validationErrorNode.classList.remove('hidden');
      return;
    }

    const pincodeHeaders = new Headers();
    pincodeHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      'postal_code': pincode
    });

    const requestOptions = {
      method: 'POST',
      headers: pincodeHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    // fetch('https://levisshiprocket.marmeto.com/get/delivery-time', requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     const range = result.data.data.available_courier_companies.sort((a,b)=>{
    //       if(a.etd_hours < b.etd_hours) return 1;
    //       return -1;
    //     })
    //     const max = range[0].etd;
        
    //     if(max) {
    //       this.estDeliveryNode.classList.remove('hidden');
    //       this.estDeliveryNode.textContent = ('Expected Delivery by ' + max );
    //     }
    //   })
    //   .catch((error) => {
    //     console.log('error', error);
    //     this.failureNode.classList.remove('hidden');
    //   });
    fetch('https://levisshiprocket.marmeto.com/get/delivery-time', requestOptions)
  .then((response) => response.json())
  .then((result) => {
    const range = result.data.data.available_courier_companies.sort((a, b) => {
      if (a.etd_hours < b.etd_hours) return 1;
      return -1;
    });

    const max = range[0].etd;

    if (max) {
      const deliveryDate = new Date(max);
      deliveryDate.setDate(deliveryDate.getDate() + 0);
      
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = deliveryDate.toLocaleDateString(undefined, options);

      this.estDeliveryNode.classList.remove('hidden');
      this.estDeliveryNode.textContent = 'Expected Delivery by ' + formattedDate;
    }
  })
  .catch((error) => {
    console.log('error', error);
    this.failureNode.classList.remove('hidden');
  });
  
  }
  
  reuseLocalStorageData() {
    if (!localStorage.getItem('pincode')) return;
    this.input.value = localStorage.getItem('pincode')
    this.checkPincodeAvailability()
  }


  handleInput() {
    // Remove non-numeric characters from the input
    let numericValue = this.input.value.replace(/[^0-9]/g, '');

    // Limit the input to 6 digits
    if (numericValue.length > 6) {
      numericValue = numericValue.slice(0, 6);
    }

    // Update the input field with the sanitized value
    this.input.value = numericValue;

    // You can also add additional validation logic if needed
  }
}

customElements.define('pincode-checker', PincodeChecker);